import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Controller } from 'react-hook-form';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { NO_SELECT_NUMBER } from 'constants/form';
import {
  ProfileFormItems,
  ProfileFormControl,
  ProfileFormValues,
} from 'types/profile';
import { Selectbox } from 'components/atoms';
import { Field } from 'components/molecules';

type Value = {
  newGraduate: Pick<ProfileFormValues['newGraduate'], 'preferredWorkStyleId'>;
};

type NewGraduatePreferredWorkingStyleFormFieldProps = {
  error: string | undefined;
  control: ProfileFormControl<Value>;
  preferredWorkStyles: ProfileFormItems['preferredWorkStyles'];
};

const StyledSelectbox = styled(Selectbox)`
  width: 368px;

  ${media.mobile} {
    width: 100%;
  }
`;

const NewGraduatePreferredWorkingStyleFormField: FC<NewGraduatePreferredWorkingStyleFormFieldProps> = props => {
  const { error, control, preferredWorkStyles } = props;

  return (
    <Field
      label={MESSAGES.PROFILE.FIELD.NEW_GRADUATE_PREFERRED_WORKING_STYLE.LABEL}
      required
    >
      <Controller
        control={control}
        name="newGraduate.preferredWorkStyleId"
        render={innerProps => (
          <StyledSelectbox
            value={innerProps.value}
            error={error}
            options={preferredWorkStyles}
            aria-label={
              MESSAGES.PROFILE.FIELD.NEW_GRADUATE_PREFERRED_WORKING_STYLE.LABEL
            }
            onChange={innerProps.onChange}
            onBlur={innerProps.onBlur}
            noSelectValue={NO_SELECT_NUMBER}
          />
        )}
      />
    </Field>
  );
};

export default NewGraduatePreferredWorkingStyleFormField;
